import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { Row, Col, ButtonGroup, Button } from 'reactstrap';
import { useParams, Link } from "react-router-dom";
import MemberForm from '../MemberForm/MemberForm';
import PageTitle from '../../../components/PageTitle/PageTitle';
import Icon from '@mdi/react';
import { mdiAccountOutline, mdiAccountSchoolOutline, mdiFileDownloadOutline } from '@mdi/js';

import { loadMember, updateMember, downloadMemberCardPdf } from '../../../redux/modules';

const MemberEdit = props => {
    const { memberId } = useParams();

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadMember(memberId));
    }, [ memberId ]);

    const { t }        = useTranslation();
    const { isLoading, member } = useSelector(state => state.members);
    const current_user = useSelector(state => state.auth.user);

    if (!current_user || !member)
        return null;

    const submit = values => {
        dispatch(updateMember(values));
    }

    const downloadMemberCard = (member) => {
        dispatch(downloadMemberCardPdf(member));
    }

    const title = current_user.id === member.id ?
        <span>{t('members.update_my_profile')}</span>
        :
        <span>
            {t('members.member')}
            <small> | {t('members.update_member', {firstname: member.firstname, lastname: member.lastname})}</small>
        </span>

    const actions = (
        <div>
            {member &&
            <ButtonGroup>
                <Button onClick={ () => downloadMemberCard(member) } color="info">
                    <Icon path={mdiFileDownloadOutline} size={1} />&nbsp;
                    { t('members.download_member_card_pdf') }
                </Button>
                <Button tag={Link} to={ -1 } color="warning" size="sm">
                    <i className="fa fa-arrow-left"></i>&nbsp;
                    {t('common.back')}
                </Button>
            </ButtonGroup>
            }
        </div>
    )

    return (
        <div className="MemberEdit">
            <PageTitle icon={mdiAccountSchoolOutline} title={ title } actions={ actions } />

            {member &&
                <>
                    {!!member.user_id && (
                    <Row className="align-items-center justify-content-start">
                        <Col xs="auto">
                            <ButtonGroup>
                                <Button tag={Link} color="dark" to={`/users/edit/${member.user_id}`}>
                                    <Icon path={mdiAccountOutline} size={1} color="white" />&nbsp;
                                    {t('users.user_profile')}
                                </Button>
                                <Button tag={Link} color="info" to={`/members/edit/${member.id}`}>
                                    <Icon path={mdiAccountSchoolOutline} size={1} color="white" />&nbsp;
                                    {t('users.member_profile')}
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                    )}
                    <MemberForm memberId={member.id} onSubmit={submit} />
                </>
            }
        </div>
    );
}

export default MemberEdit;
